export default [
    {
        hidden: false, // hidden - if true, the step will not be shown steps header
        step: 1, // order - manual number. The order of the array determins the steporder
        name: 'StafetDonationTaendLysStepOne', // stepname. Must correspond to a component declared under "components"
        label: 'formStepLabel1',
        completed: false // are all fields valid?
    },
    {
        hidden: false, // hidden - if true, the step will not be shown steps header
        step: 2, // order - manual number. The order of the array determins the steporder
        name: 'StafetDonationTaendLysStepTwo', // stepname. Must correspond to a component declared under "components"
        label: 'formStepLabel2',
        completed: false // are all fields valid?
    },
    {
        hidden: false, // hidden - if true, the step will not be shown steps header
        step: 3, // order - manual number. The order of the array determins the steporder
        name: 'StafetDonationTaendLysStepThree', // stepname. Must correspond to a component declared under "components"
        label: 'formStepLabel3',
        completed: false // are all fields valid?
    },
    {
        hidden: true, // hidden - if true, the step will not be shown steps header
        step: 4, // order - manual number. The order of the array determins the steporder
        name: 'FormStepSubmitting', // stepname. Must correspond to a component declared under "components"
        label: 'submitErrorTitle',
        completed: false // are all fields valid?
    }
]
